import React from 'react';
import { AccordionSummaryProps } from '@material-ui/core/AccordionSummary';
import Skeleton from '@material-ui/lab/Skeleton';

import PlanTermContext from './context';
import AccordionSummary from './AccordionSummary';
import AccordionTimeline from './AccordionTimeline';
import Summary from './Summary';
import MoreSeeButton from './MoreSeeButton';
import MeetingTimelineItem from './MeetingTimelineItem';

export type PlanTermAccordionSummaryProps = AccordionSummaryProps & {
  skeleton?: boolean,
  index?: number,
};

const PlanTermAccordionSummary = ({
  skeleton,
  index,
  expanded,
  toggleExpanded,
  ...props
}: PlanTermAccordionSummaryProps) => {
  const { planTerm, isEditing } = React.useContext(PlanTermContext);
  const isMeetingHidden =
    !isEditing && !(planTerm.meetingPlace && planTerm.meetingTime);

  return (
    <AccordionSummary {...props}>
      {skeleton ? (
        <Skeleton
          variant="text"
          width="100%"
          height={40}
          style={{ maxWidth: 300 }}
        />
      ) : (
        <div>
          <div>
            <Summary index={index} />
          </div>
          <AccordionTimeline expanded={expanded}>
            <MeetingTimelineItem isMeetingHidden={isMeetingHidden} />
          </AccordionTimeline>
          <MoreSeeButton
            expanded={expanded}
            isShow={!expanded}
            onClick={toggleExpanded}
          />
        </div>
      )}
    </AccordionSummary>
  );
};

export default PlanTermAccordionSummary;
